import * as React from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    AccordionSummaryProps,
    accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { HeaderBox } from './mBookListPage';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PravachanService from "../../Services/Pravachans";
import i18n, { _get_i18Lang } from '../../i18n';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AudiosService from "../../Services/Audios";
// import "../../Pages/MobileCss/Common.css";

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled(
    (props: AccordionSummaryProps & { expanded?: boolean }) => (
        <MuiAccordionSummary
            expandIcon={props.expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            {...props}
        />
    )
)(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
        transform: 'rotate(0deg)',
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
    [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
        alignItems: 'center',
        margin: 0,
        display: 'flex',
    },
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: 'none',
    backgroundColor: "white"
}));
const months = [
    { id: 1, name: "जनवरी" },
    { id: 2, name: "फ़रवरी" },
    { id: 3, name: "मार्च" },
    { id: 4, name: "अप्रैल" },
    { id: 5, name: "मई" },
    { id: 6, name: "जून" },
    { id: 7, name: "जुलाई" },
    { id: 8, name: "अगस्त" },
    { id: 9, name: "सितंबर" },
    { id: 10, name: "अक्टूबर" },
    { id: 11, name: "नवंबर" },
    { id: 12, name: "दिसंबर" },
];
export default function CategoriesFilter() {
    const [expanded, setExpanded] = React.useState<string | false>('panel1');
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [categories, setCategories] = React.useState<any[]>([]);
    const [recordCounts, setRecordCounts] = React.useState<any[]>([]);
    const [selectedCategory, setSelectedCategory] = React.useState<any>("");

    const [year, setYear] = React.useState<any>();
    const [time, setTime] = React.useState<any>();
    const [selectedYear, setSelectedYear] = React.useState<string>("");

    const [selectedMonth, setSelectedMonth] = React.useState<string>("");
    const [selectedSamay, setSelectedSamay] = React.useState<string>("");

    // single state for dropdown
    const [openMenu, setOpenMenu] = React.useState<null | "year" | "month" | "samay">(null);

    const location: any = useLocation();
    const scrollRef = React.useRef<HTMLDivElement>(null);

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };

    React.useEffect(() => {
        const fetchCategories = async () => {
            try {
                const language = _get_i18Lang();
                const response = await PravachanService.getMobilePravachanCategory(language);
                if (response?.status && response?.result) {
                    setCategories(response.result);
                }
            } catch (error) {
                console.error("Error fetching categories", error);
            }
        };
        fetchCategories();
    }, []);

    React.useEffect(() => {
        const fetchRecordCount = async () => {
            try {
                const response = await PravachanService.getMobileRecordCount(
                    "categories",
                    "pravachan",
                    "",
                    "",
                    location?.state?.authorId,
                    ''
                );
                if (response?.status && response?.result) {
                    setRecordCounts(response.result);
                }
            } catch (error) {
                console.error("Error fetching record count", error);
            }
        };
        fetchRecordCount();
    }, []);

    const getRecordCountById = (id: string) => {
        const found = recordCounts.find((rc: any) => rc.id === id);
        return found ? `(${found.recordCount})` : 0;
    };

    React.useEffect(() => {
        if(location?.state?.orderNo === 3){
        const fetchYearData = async () => {
            try {
                const response = await AudiosService.getYearReaponse();
                if (response?.status && response?.result) {
                    setYear(response.result);
                }
            }
            catch (error) {
                console.log("Error fetching record count", error);
            }
        };
        const fetchTimeData = async () => {

            try {
                const response = await AudiosService.getTimeReaponse();
                if (response?.status && response?.result) {
                    setTime(response.result);
                }
            }
            catch (error) {
                console.log("Error fetching record count", error);
            }
        };
        fetchYearData();
        fetchTimeData();
    }
    }, [location?.state?.orderNo === 3]);

    React.useEffect(() => {
        const handleScroll = () => {
            if (openMenu) {
                setOpenMenu(null);
            }
        };

        const scrollableDiv = scrollRef.current;
        if (scrollableDiv) {
            scrollableDiv.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (scrollableDiv) {
                scrollableDiv.removeEventListener("scroll", handleScroll);
            }
        };
    }, [openMenu]);
    return (
        <div style={{ backgroundColor: "whitesmoke", height: "100vh", display: "flex", flexDirection: "column" }}>
            {/* Fixed Header */}
            <div style={{ flexShrink: 0 }}>
                <HeaderBox>
                    <IconButton
                        onClick={() => navigate(-1)}
                        sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}
                    >
                        <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                    </IconButton>
                    <IconButton
                        onClick={() => navigate("/")}
                        sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}
                    >
                        <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                    </IconButton>

                    <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                        {t("shrihari_tr")}
                    </Typography>
                </HeaderBox>
            </div>

            {/* Scrollable content */}
            <div ref={scrollRef} style={{ flex: 1, overflowY: "auto", paddingBottom: "60px" }}>

                {/* Categories */}
                <div className='mb-1' style={{ backgroundColor: "white" }}>
                    <div
                        style={{ width: "100%", fontSize: 22, fontWeight: "bold", fontFamily: "chanakyaUni" }}
                        className='pl-3 pt-2'
                    >
                        श्रेणियाँ
                    </div>

                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary expanded={expanded === 'panel1'} aria-controls="panel1d-content" id="panel1d-header" style={{ backgroundColor: "white" }}>
                            <Typography component="span" style={{ fontFamily: "chanakyaUni", fontSize: 20 }}>
                                {selectedCategory ? `${selectedCategory.name} ${getRecordCountById(selectedCategory.id)}` : "सभी श्रेणियां"}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                         
                            <div
                                onClick={() => { setSelectedCategory(null); setExpanded(false); }}
                                style={{
                                    padding: "8px 0",
                                    fontSize: 18,
                                    fontFamily: "chanakyaUni",
                                    display: "flex",
                                    cursor: "pointer",
                                    fontWeight: !selectedCategory ? "bold" : "normal"
                                }}
                            >
                                <span>सभी श्रेणियां</span>
                                <span style={{ fontSize: 16, paddingLeft: 10 }}>
                                    ({recordCounts.reduce((sum, rc) => sum + rc.recordCount, 0)})
                                </span>
                            </div>

                      
                            {categories.map((category) => (
                                <div
                                    key={category.id}
                                    onClick={() => { setSelectedCategory(category); setExpanded(false); }}
                                    style={{
                                        padding: "8px 0",
                                        fontSize: 18,
                                        fontFamily: "chanakyaUni",
                                        display: "flex",
                                        cursor: "pointer",
                                        fontWeight: selectedCategory?.id === category.id ? "bold" : "normal"
                                    }}
                                >
                                    <span>{category.name}</span>
                                    <span style={{ fontSize: 16, paddingLeft: 10 }}>
                                        {getRecordCountById(category.id)}
                                    </span>
                                </div>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                </div>

                {/* Year Dropdown */}
{
    location?.state?.orderNo === 3 && (
        <>
            {/* Year Dropdown */}
            <div className='mb-1' style={{ backgroundColor: "white", padding: 5 }}>
                वर्ष
                <div
                    style={{ display: "flex", justifyContent: "space-between", backgroundColor: "#F8EDE1", margin: 5, padding: 10 }}
                    onClick={() => setOpenMenu(openMenu === "year" ? null : "year")}
                >
                    <div>{selectedYear || "सभी वर्ष"}</div>
                    <KeyboardArrowDownIcon sx={{ fontSize: 20, color: "#6B6B6B" }} />
                </div>
            </div>

            {openMenu === "year" && (
                <div
                    style={{
                        backgroundColor: "#F8EDE1",
                        zIndex: 9999,
                        position: "fixed",
                        width: "92%",
                        left: "3%",
                        top: expanded ? 465 : undefined,
                        borderRadius: 2,
                        boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                        padding: 10,
                        maxHeight: "250px",
                        overflowY: "auto",
                    }}
                    className='scroll-hidden'
                >
                    <h5 style={{ fontWeight: 500 }} onClick={() => { setSelectedYear(""); setOpenMenu(null); }}>सभी वर्ष</h5>
                    {year?.map((yr: any) => (
                        <div
                            key={yr?.name}
                            style={{ padding: 8, fontSize: 18, fontFamily: "chanakyaUni", cursor: "pointer" }}
                            onClick={() => { setSelectedYear(yr?.name); setOpenMenu(null); }}
                        >
                            {yr?.name}
                        </div>
                    ))}
                </div>
            )}

            {/* Month Dropdown */}
            <div className='mb-1' style={{ backgroundColor: "white", padding: 5 }}>
                महीना
                <div
                    style={{ display: "flex", justifyContent: "space-between", backgroundColor: "#F8EDE1", margin: 5, padding: 10 }}
                    onClick={() => setOpenMenu(openMenu === "month" ? null : "month")}
                >
                    <div>{selectedMonth || "सभी महीने"}</div>
                    <KeyboardArrowDownIcon sx={{ fontSize: 20, color: "#6B6B6B" }} />
                </div>
            </div>

            {openMenu === "month" && (
                <div
                    style={{
                        backgroundColor: "#F8EDE1",
                        zIndex: 9999,
                        position: "fixed",
                        width: "92%",
                        left: "3%",
                        top: expanded ? 558 : undefined,
                        borderRadius: 2,
                        boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                        padding: 10,
                        maxHeight: "180px",
                        overflowY: "auto",
                    }}
                    className='scroll-hidden'
                >
                    <h5 style={{ fontWeight: 500 }} onClick={() => { setSelectedMonth(""); setOpenMenu(null); }}>सभी महीने</h5>
                    {months.map((m) => (
                        <div
                            key={m.id}
                            style={{ padding: 8, fontSize: 18, fontFamily: "chanakyaUni", cursor: "pointer" }}
                            onClick={() => { setSelectedMonth(m.name); setOpenMenu(null); }}
                        >
                            {m.name}
                        </div>
                    ))}
                </div>
            )}

            {/* Samay Dropdown */}
            <div className='mb-1' style={{ backgroundColor: "white", padding: 5 }}>
                समय
                <div
                    style={{ display: "flex", justifyContent: "space-between", backgroundColor: "#F8EDE1", margin: 5, padding: 10 }}
                    onClick={() => setOpenMenu(openMenu === "samay" ? null : "samay")}
                >
                    <div>{selectedSamay || "सभी समय"}</div>
                    <KeyboardArrowDownIcon sx={{ fontSize: 20, color: "#6B6B6B" }} />
                </div>
            </div>

            {openMenu === "samay" && (
                <div
                    style={{
                        backgroundColor: "#F8EDE1",
                        zIndex: 9999,
                        position: "fixed",
                        width: "92%",
                        left: "3%",
                        top: expanded ? 650 : undefined,
                        borderRadius: 2,
                        boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                        padding: 10,
                        maxHeight: "250px",
                        overflowY: "auto",
                    }}
                    className='scroll-hidden'
                >
                    <h5 style={{ fontWeight: 500 }} onClick={() => { setSelectedSamay(""); setOpenMenu(null); }}>सभी समय</h5>
                    {time?.map((tm: any) => (
                        <div
                            key={tm?.name}
                            style={{ padding: 8, fontSize: 18, fontFamily: "chanakyaUni", cursor: "pointer" }}
                            onClick={() => { setSelectedSamay(tm?.name); setOpenMenu(null); }}
                        >
                            {tm?.name}
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}


                <div style={{ display: "flex", justifyContent: "end", paddingRight: '8px' }}>
                    <button
                        onClick={() => navigate("/mobileAudioListPage", {
                            state: { 
                                categoryId: selectedCategory?.id,
                                authorId: location?.state?.authorId,
                                year: selectedYear,
                                month: selectedMonth,
                                ptime: selectedSamay,
                            }
                        })}
                        style={{
                            fontSize: "20px",
                            backgroundColor: "#f97316",
                            border: "none",
                            color: "white",
                            borderRadius: "3px"
                        }}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
}
